export const CHANNEL = {
  id: 'UC_SAFAR_KHANA_PLACEHOLDER',
  name: 'SAFAR KHANA',
  handle: '@SafarKhana',
  tagline: 'Explore · Travel · Food · Stories',
  description:
    'Chronicling the slow lanes, roadside dhabas, and high mountain passes of India. An independent visual archive of journeys across Bharat.',
  about:
    'Safar Khana documents India’s roadside kitchens, mountain passes, and heritage towns in 4K field dispatches. Started on the Grand Trunk Road in 2019, the channel preserves oral culinary recipes and overland routes without sponsor bias.',
  subscribers: '482K',
  subscriberCount: 482000,
  views: '68M',
  viewCount: 68000000,
  videoCount: '214',
  videoCountRaw: 214,
  joined: 'Joined Oct 2019',
  publishedAt: '2019-10-12T00:00:00Z',
  youtubeUrl: 'https://www.youtube.com',
  avatar:
    'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=200&h=200&fit=crop',
  banner:
    'https://images.unsplash.com/photo-1524492412937-b28074a5d7da?w=1920&h=1080&fit=crop',
};

export const CATEGORIES = [
  'Food',
  'Travel',
  'Hotels',
  'Street Food',
  'Road Trips',
  'Vlogs',
];

export const VIDEOS = [
  {
    id: 'featured-1',
    title:
      'Winter Dawn in Purani Dilli: 120-Year-Old Nihari & Hidden Gallis of Matia Mahal',
    description:
      'Documenting early morning cauldrons behind Jama Masjid, overnight shank nihari, and century-old spice traders in Matia Mahal.\n\n00:00 Dawn at Jama Masjid\n04:15 The 120-Year-Old Nihari Deg\n11:30 Khamiri Roti by the Coal Oven\n18:45 Matia Mahal Tea Stalls',
    thumbnail:
      'https://images.unsplash.com/photo-1585937421612-70a008356fbe?w=1600&h=900&fit=crop',
    duration: '24:18',
    durationSec: 1458,
    published: '2 days ago',
    publishedAt: '2026-09-25T04:30:00Z',
    views: '142K',
    viewCount: 142000,
    badge: '4K HDR',
    fieldEntry: '#214',
    isShort: false,
    tags: ['Delhi', 'StreetFood', 'Travel', 'India', 'SafarKhana'],
    categories: ['Food', 'Street Food'],
  },
  {
    id: 'v1',
    title: "The Solitude of Spiti: Driving the World's Highest Fuel Station",
    description:
      'Overland drive through Spiti’s barren cliffs to Kaza’s high-altitude petrol pump, with cold stone dusk light and empty high passes.',
    thumbnail:
      'https://images.unsplash.com/photo-1626621341517-bbf3d9990a86?w=800&h=450&fit=crop',
    duration: '18:45',
    durationSec: 1125,
    published: '3 days ago',
    publishedAt: '2026-09-24T10:00:00Z',
    views: '89K',
    viewCount: 89000,
    isShort: false,
    tags: ['Spiti', 'Himachal', 'RoadTrips', 'Travel'],
    categories: ['Travel', 'Road Trips'],
  },
  {
    id: 'v2',
    title: 'Kolkata Cabin Culture: Moghlai Paratha & 80-Year Cutlets',
    description:
      'Heritage cabin cafés of Shyambazar — golden Moghlai paratha, beetroot cutlets, and filament-bulb evenings.',
    thumbnail:
      'https://images.unsplash.com/photo-1589302168068-964664d93dc0?w=800&h=450&fit=crop',
    duration: '21:10',
    durationSec: 1270,
    published: '1 week ago',
    publishedAt: '2026-09-20T10:00:00Z',
    views: '195K',
    viewCount: 195000,
    isShort: false,
    tags: ['Kolkata', 'Food', 'StreetFood'],
    categories: ['Food', 'Street Food'],
  },
  {
    id: 'v3',
    title: 'Hidden Heritage Haveli in Shekhawati: Painted Walls & Bajra Roti',
    description:
      'Frescoed courtyards of Shekhawati and bajra roti on a clay chulha under desert afternoon light.',
    thumbnail:
      'https://images.unsplash.com/photo-1477587458883-47145ed94245?w=800&h=450&fit=crop',
    duration: '16:30',
    durationSec: 990,
    published: '2 weeks ago',
    publishedAt: '2026-09-13T10:00:00Z',
    views: '110K',
    viewCount: 110000,
    isShort: false,
    tags: ['Rajasthan', 'Hotels', 'Travel'],
    categories: ['Travel', 'Hotels'],
  },
  {
    id: 'v4',
    title: "Midnight Dhabas of GT Road: Kali Dal, Butter Naan & Truckers' Stories",
    description:
      'National Highway 44 after midnight — iron tandoors, kali dal with white butter, and truckers’ roadside tales.',
    thumbnail:
      'https://images.unsplash.com/photo-1567337710282-00832b415979?w=800&h=450&fit=crop',
    duration: '26:05',
    durationSec: 1565,
    published: '3 weeks ago',
    publishedAt: '2026-09-06T10:00:00Z',
    views: '340K',
    viewCount: 340000,
    isShort: false,
    tags: ['Punjab', 'StreetFood', 'RoadTrips'],
    categories: ['Food', 'Road Trips', 'Street Food'],
  },
  {
    id: 'v5',
    title: 'Amritsar Food Pilgrimage: Kulcha Land to Langar at 3 AM',
    description:
      'From blistered Amritsari kulcha to the night kitchens feeding langar — a food pilgrimage through the holy city.',
    thumbnail:
      'https://images.unsplash.com/photo-1596797038530-2c107229654b?w=800&h=450&fit=crop',
    duration: '22:40',
    durationSec: 1360,
    published: '1 month ago',
    publishedAt: '2026-08-27T10:00:00Z',
    views: '2.4M',
    viewCount: 2400000,
    isShort: false,
    tags: ['Amritsar', 'Food', 'India'],
    categories: ['Food', 'Street Food'],
  },
  {
    id: 'v6',
    title: '48 Hours in Varanasi: Ghats, Malaiyo & Silk Weavers',
    description:
      'Dawn on the ghats, winter malaiyo froth, and Banarasi silk looms in a two-day city immersion.',
    thumbnail:
      'https://images.unsplash.com/photo-1561361513-2d000a50f0dc?w=800&h=450&fit=crop',
    duration: '41:05',
    durationSec: 2465,
    published: '1 month ago',
    publishedAt: '2026-08-20T10:00:00Z',
    views: '1.9M',
    viewCount: 1900000,
    isShort: false,
    tags: ['Varanasi', 'Travel', 'Food'],
    categories: ['Travel', 'Vlogs', 'Food'],
  },
  {
    id: 'v7',
    title: 'Kashmir in Autumn: Wazwan Feast & Chinar Leaves',
    description:
      'Autumn chinars of Dachigam and a full wazwan table — Kashmir’s festive kitchen in season.',
    thumbnail:
      'https://images.unsplash.com/photo-1595815771614-ade9d652a65d?w=800&h=450&fit=crop',
    duration: '32:10',
    durationSec: 1930,
    published: '5 weeks ago',
    publishedAt: '2026-08-15T10:00:00Z',
    views: '1.6M',
    viewCount: 1600000,
    isShort: false,
    tags: ['Kashmir', 'Food', 'Travel'],
    categories: ['Travel', 'Food'],
  },
  {
    id: 'v8',
    title: 'The Frozen River of Zanskar: Winter Highway Expedition',
    description:
      'Crossing the Chadar ice route — a winter highway of frozen turquoise and high Himalayan silence.',
    thumbnail:
      'https://images.unsplash.com/photo-1582510003544-4d00b7f74220?w=800&h=450&fit=crop',
    duration: '18:45',
    durationSec: 1125,
    published: '6 weeks ago',
    publishedAt: '2026-08-10T10:00:00Z',
    views: '1.4M',
    viewCount: 1400000,
    isShort: false,
    tags: ['Ladakh', 'Zanskar', 'RoadTrips'],
    categories: ['Travel', 'Road Trips'],
  },
  {
    id: 's1',
    title: 'Secret chai spot on Rohtang pass',
    description: 'Boiling masala chai on a windy high ridge at Rohtang.',
    thumbnail:
      'https://images.unsplash.com/photo-1571934811356-5cc061b6821f?w=400&h=711&fit=crop',
    duration: '0:48',
    durationSec: 48,
    published: '4 days ago',
    publishedAt: '2026-09-23T10:00:00Z',
    views: '380K',
    viewCount: 380000,
    isShort: true,
    tags: ['Himachal', 'Chai', 'Shorts'],
    categories: ['Travel'],
  },
  {
    id: 's2',
    title: 'Crispiest Jalebi in Chandni Chowk',
    description: 'Saffron jalebis frying in desi ghee in Old Delhi.',
    thumbnail:
      'https://images.unsplash.com/photo-1606491956689-2ea866880067?w=400&h=711&fit=crop',
    duration: '0:54',
    durationSec: 54,
    published: '5 days ago',
    publishedAt: '2026-09-22T10:00:00Z',
    views: '1.2M',
    viewCount: 1200000,
    isShort: true,
    tags: ['Delhi', 'StreetFood', 'Shorts'],
    categories: ['Street Food', 'Food'],
  },
  {
    id: 's3',
    title: 'Morning mist over tea gardens of Munnar',
    description: 'Mist rolling over stepped tea plantations at dawn.',
    thumbnail:
      'https://images.unsplash.com/photo-1595815771614-ade9d652a65d?w=400&h=711&fit=crop',
    duration: '0:51',
    published: '1 week ago',
    publishedAt: '2026-09-20T08:00:00Z',
    views: '450K',
    viewCount: 450000,
    durationSec: 51,
    isShort: true,
    tags: ['Kerala', 'Travel', 'Shorts'],
    categories: ['Travel'],
  },
  {
    id: 's4',
    title: 'The 4 AM Lassi master of Varanasi',
    description: 'Wooden-vat lassi and clay kulhads before sunrise.',
    thumbnail:
      'https://images.unsplash.com/photo-1546833999-b9f581a1996d?w=400&h=711&fit=crop',
    duration: '0:58',
    durationSec: 58,
    published: '2 weeks ago',
    publishedAt: '2026-09-13T04:00:00Z',
    views: '890K',
    viewCount: 890000,
    isShort: true,
    tags: ['Varanasi', 'Food', 'Shorts'],
    categories: ['Food', 'Street Food'],
  },
  {
    id: 's5',
    title: 'Crossing the Kunzum Pass river bed',
    description: 'Motorcycle splash through icy turquoise water at Kunzum.',
    thumbnail:
      'https://images.unsplash.com/photo-1506905925346-21bda4d32df4?w=400&h=711&fit=crop',
    duration: '0:45',
    durationSec: 45,
    published: '3 weeks ago',
    publishedAt: '2026-09-06T12:00:00Z',
    views: '620K',
    viewCount: 620000,
    isShort: true,
    tags: ['Spiti', 'RoadTrips', 'Shorts'],
    categories: ['Road Trips', 'Travel'],
  },
];

export const PLAYLISTS = [
  {
    id: 'p1',
    title: 'Travel Vlogs',
    description:
      'Unfiltered journeys across backwaters, royal forts, and forgotten border posts.',
    thumbnail:
      'https://images.unsplash.com/photo-1488646953014-85cb44e25828?w=800&h=450&fit=crop',
    videoCount: 24,
    updated: 'Updated recently',
    videoIds: ['v1', 'v6', 'v7', 'v8', 'featured-1', 'v3'],
  },
  {
    id: 'p2',
    title: 'Street Food India',
    description:
      'Century-old dhabas, dawn breakfasts, and secret spice recipes across India’s oldest alleys.',
    thumbnail:
      'https://images.unsplash.com/photo-1601050690597-df0568f70950?w=800&h=450&fit=crop',
    videoCount: 32,
    updated: 'Updated recently',
    videoIds: ['featured-1', 'v2', 'v4', 'v5', 's2', 's4'],
  },
  {
    id: 'p3',
    title: 'Himachal Diaries',
    description:
      'Deep valleys, apple orchards, high altitude passes, and winter snow trails.',
    thumbnail:
      'https://images.unsplash.com/photo-1597074866922-c2c4efbfcac5?w=800&h=450&fit=crop',
    videoCount: 18,
    updated: 'Updated recently',
    videoIds: ['v1', 's1', 's5', 'v8'],
  },
  {
    id: 'p4',
    title: 'Road Trips',
    description:
      'Grand Trunk Road, coastal highways, and overland off-road documentation.',
    thumbnail:
      'https://images.unsplash.com/photo-1469854523086-cc02fe5d8800?w=800&h=450&fit=crop',
    videoCount: 20,
    updated: 'Updated recently',
    videoIds: ['v4', 'v1', 'v8', 's5'],
  },
  {
    id: 'p5',
    title: 'Hotel Reviews',
    description:
      'Heritage dharamsalas, circuit houses, and boutique Himalayan retreats.',
    thumbnail:
      'https://images.unsplash.com/photo-1566073771259-6a8506099945?w=800&h=450&fit=crop',
    videoCount: 12,
    updated: 'Updated recently',
    videoIds: ['v3'],
  },
  {
    id: 'p6',
    title: 'Heritage & Ancient Towns',
    description:
      'Painted havelis, ghats, and living history towns filmed on foot.',
    thumbnail:
      'https://images.unsplash.com/photo-1524492412937-b28074a5d7da?w=800&h=450&fit=crop',
    videoCount: 16,
    updated: 'Updated recently',
    videoIds: ['v3', 'v6', 'featured-1'],
  },
];
